const parliamentaryManagement = {
  en: {
    parliamentaryManagementPage: {
      regions: {
        "Adamawa": "Adamawa", "Centre": "Centre", "East": "East", "Far North": "Far North", "Littoral": "Littoral",
        "North": "North", "North-West": "North-West", "South": "South", "South-West": "South-West", "West": "West"
      },
      title: "Parliamentary Elections Management",
      subtitle: "180 Constituencies • Proportional Representation",
      shareTitle: "EReMS Cameroon - Parliamentary Election Results",
      shareText: "🏛️ Parliamentary Elections: {{count}}/180 constituencies reporting!",
      refresh: "Refresh",
      unknown: "Unknown",
      national: "National",
      stats: {
        constituencies: "Constituencies",
        totalVotes: "Total Votes",
        validVotes: "Valid Votes",
        rejectedVotes: "Rejected Votes"
      },
      leadingParty: "Leading Party",
      votesCount: "{{count}} votes",
      tabs: {
        overview: "Overview",
        candidates: "Candidates ({{count}})",
        results: "Results ({{count}})"
      },
      overview: {
        partyResults: "Party Results",
        noResultsData: "No results data available",
        voteShare: "Vote Share",
        noData: "No data available"
      },
      candidatesTab: {
        title: "Registered Candidates",
        filterPlaceholder: "Filter by region",
        allRegions: "All Regions",
        none: "No candidates found"
      },
      resultsTab: {
        title: "Election Results",
        none: "No results available"
      }
    }
  },
  fr: {
    parliamentaryManagementPage: {
      regions: {
        "Adamawa": "Adamaoua", "Centre": "Centre", "East": "Est", "Far North": "Extrême-Nord", "Littoral": "Littoral",
        "North": "Nord", "North-West": "Nord-Ouest", "South": "Sud", "South-West": "Sud-Ouest", "West": "Ouest"
      },
      title: "Gestion des élections législatives",
      subtitle: "180 circonscriptions • Représentation proportionnelle",
      shareTitle: "EReMS Cameroon - Résultats des élections législatives",
      shareText: "🏛️ Élections législatives : {{count}}/180 circonscriptions ont transmis leurs résultats !",
      refresh: "Actualiser",
      unknown: "Inconnu",
      national: "National",
      stats: {
        constituencies: "Circonscriptions",
        totalVotes: "Total des votes",
        validVotes: "Votes valides",
        rejectedVotes: "Votes rejetés"
      },
      leadingParty: "Parti en tête",
      votesCount: "{{count}} voix",
      tabs: {
        overview: "Aperçu",
        candidates: "Candidats ({{count}})",
        results: "Résultats ({{count}})"
      },
      overview: {
        partyResults: "Résultats par parti",
        noResultsData: "Aucune donnée de résultats disponible",
        voteShare: "Part des voix",
        noData: "Aucune donnée disponible"
      },
      candidatesTab: {
        title: "Candidats enregistrés",
        filterPlaceholder: "Filtrer par région",
        allRegions: "Toutes les régions",
        none: "Aucun candidat trouvé"
      },
      resultsTab: {
        title: "Résultats des élections",
        none: "Aucun résultat disponible"
      }
    }
  }
};

export default parliamentaryManagement;
